import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message, notification } from 'antd';
import { I18n } from '@aws-amplify/core';
import Api from '@/services/api';

import { Evaluator } from '@/types';
import { CreateEvaluatorRequest } from '@/components/ui/Inputs/types/request';

export const useCreateEvaluator = () => {
	const queryClient = useQueryClient();
	return useMutation((body: CreateEvaluatorRequest) => Api.post<Evaluator>('/evaluator', body), {
		onError: (err: any) => {
			notification.error({
				message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries(['evaluators']);
			message.success(I18n.get('Evaluator created successfully'));
		}
	});
};
